module.exports = "<div class=\"row\">\r\n    <div class=\"col-md-5\">\r\n        <app-recipe-list></app-recipe-list>\r\n    </div>\r\n    <div class=\"col-md-7\">\r\n        <app-recipe-detail \r\n        *ngIf=\"selectedRecipe; else infoText\" \r\n        [recipe]=\"selectedRecipe\">\r\n    </app-recipe-detail>\r\n        <ng-template #infoText>\r\n            <p>Please select the recipe</p>\r\n        </ng-template>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/gitHub/cookbook/src/app/components/recipe-book/recipe-book.component.html
// module id = ../../../../../src/app/components/recipe-book/recipe-book.component.html
// module chunks = main